const EMOJI_LIST = [
  '🏠','🚗','📱','⌚','🏫','💼','✈️','📦','⭐',
  '🎮','🎵','🏋️','🐶','🌱','💰','🎨','📚','🍔',
  '👗','💍','🎂','🏆','🎁',
];

export default function EmojiPicker({ value, onChange }) {
  return (
    <div className="emoji-picker-grid">
      {EMOJI_LIST.map((emoji) => (
        <button
          key={emoji}
          type="button"
          className={`emoji-picker-btn${value === emoji ? ' emoji-picker-btn--active' : ''}`}
          onClick={() => onChange(emoji)}
        >
          {emoji}
        </button>
      ))}
    </div>
  );
}
